module.exports = __webpack_public_path__ + "img/invite.665c4e22.svg";